import { Icon } from '@chakra-ui/icons'
import { IconProps } from '@chakra-ui/react'
import { FC } from 'react'

const PadlockUser: FC<IconProps> = (props) => (
  <Icon xmlSpace="preserve" viewBox="0 0 41 44" boxSize="32px" {...props}>
    <path
      d="M20.5 42.5H3.2c-.9 0-1.7-.7-1.7-1.7V17.2c0-.9.7-1.7 1.7-1.7h27.7c.9 0 1.7.7 1.7 1.7v5.3"
      style={{
        fill: 'none',
        stroke: '#000',
        strokeWidth: 3,
        strokeLinecap: 'round',
        strokeLinejoin: 'bevel',
        strokeMiterlimit: 10
      }}
    />
    <path
      d="M24.5 15V9.7c0-3.9-3-7.2-6.8-7.3-4-.1-7.2 3.1-7.2 7V15"
      style={{
        fill: 'none',
        stroke: '#000',
        strokeWidth: 3,
        strokeMiterlimit: 10
      }}
    />
    <path d="M31.1 34c.9 0 1.7-.3 2.4-1s1-1.4 1-2.4-.3-1.7-1-2.3c-.7-.6-1.4-1-2.4-1-.9 0-1.7.3-2.3 1-.6.6-1 1.4-1 2.3 0 .9.3 1.7 1 2.4.6.7 1.4 1 2.3 1zm0 6.6c1.1 0 2.1-.3 3.1-.8s1.8-1.2 2.3-2.1c-.9-.5-1.7-.8-2.6-1.1-.9-.3-1.8-.4-2.8-.4-1 0-1.9.1-2.8.4-.9.3-1.8.7-2.7 1.1.6.9 1.4 1.6 2.3 2.1 1.1.6 2.1.8 3.2.8zm0 3.5c-2.6 0-4.9-1-6.8-2.8-1.9-1.9-2.9-4.2-2.9-6.8 0-2.6 1-4.9 2.9-6.8s4.2-2.9 6.8-2.9c2.6 0 4.9 1 6.8 2.9 1.9 1.9 2.8 4.2 2.8 6.8 0 2.6-1 4.9-2.8 6.8-1.9 1.9-4.1 2.8-6.8 2.8z" />
  </Icon>
)
export default PadlockUser
